/* eslint-disable @typescript-eslint/no-unused-expressions */
// @ts-nocheck
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from 'redux/actions/projects';
import { errorToast, successToast } from 'utils/toastHandler';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'redux/actions/loader';
import getQueryParams from 'utils/getQueryParams';

import {
  getProjects,
  getProject,
  createProject,
  updateProject,
  deleteProject,
  favouriteProject,
  getCountries,
  getProjectClients,
  getProjectSegments,
  getProjectClaimPaymentAct,
  getProjectCodeList,
  getStates,
} from '../services/project';

import { router } from 'components/routes/Router';
import {
  handleProjectCreateSuccess,
  handleProjectUpdateSuccess,
} from 'pages/Project/utils/queryInvalidation';

const getString = (obj) => (typeof obj === 'string' ? obj : obj?.error);

function* getProjectsRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getProjects, getQueryParams(params));
    yield put({ type: types.GET_PROJECTS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_PROJECTS_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* getProjectRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getProject, params);
    yield put({
      type: types.GET_PROJECT_BY_ID_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    router.navigate('/project');
    yield put({ type: types.GET_PROJECT_BY_ID_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* checkUnidentifiedResourceCodeRequest(action) {
  try {
    const { payload } = action;
    yield put({ type: SHOW_FULLSCREEN_LOADER });
    const response = yield call(createProject, payload);
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    const { header, rows, unidentified } = response.data;
    if (!(header && rows && unidentified)) {
      router.navigate('/');
    } else {
      yield put({
        type: types.CHECK_UNIDENTIFIED_RESOURCE_CODE_SUCCESS,
        payload: response.data,
      });
      yield put({ type: types.OPEN_RESOURCE_CODE_ASSIGNMENT_MODAL });
    }
  } catch (error) {
    yield put({ type: types.CHECK_UNIDENTIFIED_RESOURCE_CODE_FAILURE });
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* postProjectRequest(action) {
  try {
    const { payload } = action;
    yield put({ type: SHOW_FULLSCREEN_LOADER });
    const response = yield call(createProject, payload);
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.POST_PROJECT_SUCCESS });
    yield put({ type: types.CLOSE_RESOURCE_CODE_ASSIGNMENT_MODAL });
    successToast('Project Created Successfully');

    yield put({ type: types.RESET_FORM_FIELD });
    if (response?.data) {
      router.navigate(`/project/budget/${response?.data?.id}/forecast`);
      handleProjectCreateSuccess();
    } else {
      router.navigate('/');
    }
  } catch (error) {
    yield put({ type: types.POST_PROJECT_FAILURE });
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* updateProjectRequest(action) {
  try {
    const { payload } = action;
    const response = yield call(updateProject, payload);
    const { header, rows, unidentified } = response.data;
    if (!(header && rows && unidentified)) {
      successToast('Project Updated Successfully');
      yield put({ type: types.RESET_FORM_FIELD });
      if (payload?.id) {
        router.navigate(`/project/budget/${payload?.id}/dashboard`);
      } else {
        router.navigate('/');
      }
      yield put({ type: types.CLOSE_RESOURCE_CODE_ASSIGNMENT_MODAL });
    } else {
      yield put({
        type: types.CHECK_UNIDENTIFIED_RESOURCE_CODE_SUCCESS,
        payload: response.data,
      });
      yield put({ type: types.OPEN_RESOURCE_CODE_ASSIGNMENT_MODAL });
    }
    if (payload?.id) {
      handleProjectUpdateSuccess(payload.id);
    }
    yield put({ type: types.UPDATE_PROJECT_BY_ID_SUCCESS });
  } catch (error) {
    yield put({ type: types.UPDATE_PROJECT_BY_ID_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* deleteProjecteRequest(action) {
  try {
    const { payload } = action;
    yield call(deleteProject, payload);
    yield put({ type: types.DELETE_PROJECT_SUCCESS });
    successToast('Project Archive Successfully');
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
    const projectInLocalStorageWithProjectAsKey = JSON.parse(
      localStorage.getItem('project'),
    );
    if (payload?.project === projectInLocalStorageWithProjectAsKey?.id) {
      localStorage.removeItem('project');
    }
  } catch (error) {
    yield put({ type: types.DELETE_PROJECT_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* favouriteProjecteRequest(action) {
  try {
    const { payload } = action;
    yield call(favouriteProject, payload);
    yield put({ type: types.FAVOURITE_PROJECT_SUCCESS, payload });
  } catch (error) {
    yield put({ type: types.FAVOURITE_PROJECT_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* getCountriesRequest() {
  try {
    const response = yield call(getCountries);
    yield put({ type: types.GET_COUNTRIES_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.GET_COUNTRIES_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* getProjectClient() {
  try {
    const response = yield call(getProjectClients);
    yield put({
      type: types.GET_PROJECT_CLIENT_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    yield put({ type: types.GET_PROJECT_CLIENT_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* getProjectSegment() {
  try {
    const response = yield call(getProjectSegments);
    yield put({
      type: types.GET_PROJECT_SEGMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_PROJECT_SEGMENT_FAILURE });
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* getProjectStates() {
  try {
    const response = yield call(getStates);
    yield put({
      type: types.GET_PROJECT_STATES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_PROJECT_STATES_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* getProjectClaimPaymentActs() {
  try {
    const response = yield call(getProjectClaimPaymentAct);
    yield put({
      type: types.GET_PROJECT_CLAIMPAYMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_PROJECT_CLAIMPAYMENT_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* getProjectCodeLists() {
  try {
    const response = yield call(getProjectCodeList);
    yield put({
      type: types.GET_PROJECT_CODELIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_PROJECT_CODELIST_FAILURE });
    getString(error?.response?.data?.error) &&
      errorToast(getString(error.response.data.error));
  }
}

function* projectMgmtWatcher() {
  yield takeLatest(types.GET_PROJECTS_REQUEST, getProjectsRequest);
  yield takeLatest(types.GET_PROJECT_BY_ID_REQUEST, getProjectRequest);
  yield takeLatest(
    types.CHECK_UNIDENTIFIED_RESOURCE_CODE_REQUEST,
    checkUnidentifiedResourceCodeRequest,
  );
  yield takeLatest(types.POST_PROJECT_REQUEST, postProjectRequest);
  yield takeLatest(types.UPDATE_PROJECT_BY_ID_REQUEST, updateProjectRequest);
  yield takeLatest(types.DELETE_PROJECT_REQUEST, deleteProjecteRequest);
  yield takeLatest(types.FAVOURITE_PROJECT_REQUEST, favouriteProjecteRequest);
  yield takeLatest(types.GET_COUNTRIES_REQUEST, getCountriesRequest);
  yield takeLatest(types.GET_PROJECT_CLIENT_REQUEST, getProjectClient);
  yield takeLatest(types.GET_PROJECT_SEGMENT_REQUEST, getProjectSegment);
  yield takeLatest(
    types.GET_PROJECT_CLAIMPAYMENT_REQUEST,
    getProjectClaimPaymentActs,
  );
  yield takeLatest(types.GET_PROJECT_CODELIST_REQUEST, getProjectCodeLists);
  yield takeLatest(types.GET_PROJECT_STATES_REQUEST, getProjectStates);
}

export default projectMgmtWatcher;
